import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

// =============================================================================
// Color Cards Animations
// =============================================================================
export function colorCardsAnimations() {
  const colorCardsContainer = document.querySelector('.color-cards')
  const colorCardsItems = document.querySelectorAll('.color-cards__card')
  
  if (!colorCardsContainer || colorCardsItems.length === 0) {
    return
  }

  // Set initial states for all elements (prevents FOUC)
  colorCardsItems.forEach(item => {
    gsap.set(item, { opacity: 0, top: 30, immediateRender: true })
    
    const iconContainer = item.querySelector('.color-cards__card-icon')
    if (iconContainer) {
      gsap.set(iconContainer, { scale: 0, immediateRender: true })
    }
  })

  // Set initial state for badges (if they exist - SVG inline may not have run yet)
  const badges = document.querySelectorAll('.color-cards__card-icon svg #badge')
  badges.forEach(badge => {
    gsap.set(badge, { scale: 0, transformOrigin: 'center center', immediateRender: true })
  })

  const colorCardsTL = gsap.timeline({
    scrollTrigger: {
      trigger: colorCardsContainer,
      start: 'top 90%',
    }
  })

  colorCardsItems.forEach((item, index) => {
    const iconContainer = item.querySelector('.color-cards__card-icon')
    const badge = item.querySelector('.color-cards__card-icon svg #badge')
    const staggerDelay = index * 0.2

    // Items
    colorCardsTL.to(item, { opacity: 1, top: 0, duration: 0.8, ease: 'power2.out' }, staggerDelay)
    
    // Icons
    if (iconContainer) {
      colorCardsTL.to(iconContainer, { scale: 1, duration: 0.6, ease: 'back.out(1.7)' }, staggerDelay + 0.3)
    }
    
    // Badges (only if they exist - SVG inline may need to run first)
    if (badge) {
      colorCardsTL.to(badge, { scale: 1, duration: 0.4, ease: 'back.out(1.7)' }, staggerDelay + 0.6)
    }
  })
}

